import type { SelectOption } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import type { OutletToFulfilFromProps } from './OutletToFulfilFrom'

export const useOutletToFulfilFromModel = (props: OutletToFulfilFromProps) => {
  const t = useT()

  return {
    label: t('Outlet to fulfill from', {
      _context: 'Label for selecting the outlet to fulfill items from',
    }),
    onOutletChange: (outlet: SelectOption | undefined) => {
      if (outlet) {
        props.onOutletChange(outlet.value)
      }
    },
    outlets: props.outlets.map(outlet => ({
      label: outlet.name,
      value: outlet.id,
    })),
  }
}
